import { analyzeContent } from 'apis/AiChat/AiChat';
import { useMutation, useQueryClient } from 'react-query';
import { AnalyzeContentInputForm } from 'types';

export const useAnalyzeContent = () => {
  const queryKeyClient = useQueryClient();
  return useMutation(
    ({ chatId, payload }: { chatId: string; payload: AnalyzeContentInputForm }) => analyzeContent(chatId, payload),
    {
      retry: false,
      onSuccess: () => {
        queryKeyClient.invalidateQueries(['chat-history']);
      },
    },
  );
};
